"use client";

import { usePostHog } from "posthog-js/react";

import type { TAllergen } from "@./suf-store";

import { FlowNavigationContext } from "../../../shared/constants";

import { useSignupFlowStore } from "./useSignUpFlowStore";

export const useFlowNavigationContext = (): FlowNavigationContext => {
  const posthog = usePostHog();
  const { cats } = useSignupFlowStore((state) => ({
    cats: state.cats,
  }));

  const inABTestGroup = (flag: string): boolean => {
    if (!posthog) { return false; }
    const flagValue = posthog.getFeatureFlag(flag);
    return flagValue === "test";
  };

  const catsAllergies = new Set(
    Object.values(cats).flatMap((cat) => cat.diet?.foodAllergies?.allergens ?? []),
  );

  const hasAnyAllergy = (excludedAllergies: TAllergen[]): boolean =>
    excludedAllergies.some((allergen) => catsAllergies.has(allergen));

  return {
    inABTestGroup,
    hasAnyAllergy,
  };
};
